import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { articleLoader } from '@shared/libs/allLoader'
import Error from '@shared/components/error'
import Layout from '@shared/components/layout'

// const HomePageContent = dynamic(() => import('@shared-components/homePageComponents/homePageContent'), { loading: () => pageLoading() })
// const HomePageArticle = dynamic(() => import('@shared-components/homePageComponents/homePageArticle'), {
//   loading: () => articleLoader(['g', 's'])
// })
const HomePageFantasyArticle = dynamic(() => import('@shared/components/homePageComponents/homePageFantasyArticle'), {
  loading: () => articleLoader(['g', 's']),
  ssr: false
})
const HomePageVideo = dynamic(() => import('@shared/components/homePageComponents/homePageVideo'), {
  loading: () => articleLoader(['g', 's']),
  ssr: false
})
const HomePageArticle = dynamic(() => import('@shared/components/homePageComponents/homePageArticle'))
const HomePageContent = dynamic(() => import('@shared/components/homePageComponents/homePageContent'))

function Home({ articles, widgetPosition, miniScorecard, scorecardHeader, stories }) {
  function getMetaDetail() {
    return {
      oSeo: {
        sTitle: 'Your Source for Daily News Updates | EverydayTimes',
        sDescription: 'EverydayTimes delivers the latest updates on global news, business, politics, and more. Stay informed with our comprehensive coverage.'
      }
    }
  }

  return (
    <Layout data={getMetaDetail()}>
      <HomePageContent
        articles={articles}
        widgetPosition={widgetPosition}
        miniScorecard={miniScorecard}
        scorecardHeader={scorecardHeader}
        stories={stories}
      >
        {(type) => {
          if (type === 'fa') return <HomePageFantasyArticle />
          else if (type === 'v') return <HomePageVideo />
          else return <HomePageArticle articles={articles} widgetPosition={widgetPosition} />
        }}
      </HomePageContent>
    </Layout >
  )
}

Home.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.object),
  widgetPosition: PropTypes.arrayOf(PropTypes.object),
  miniScorecard: PropTypes.arrayOf(PropTypes.object),
  scorecardHeader: PropTypes.arrayOf(PropTypes.object),
  stories: PropTypes.arrayOf(PropTypes.object)
}

export default Error(Home)

export async function getServerSideProps({ res, query, resolvedUrl }) {
  try {
    if (query?.p) {
      try {
        const getRedirectionURL = (await import('../shared/libs/homePage')).redirectToArticleWhenQueryHaveID
        const { returnObj } = await getRedirectionURL(query?.p)
        return returnObj
      } catch (e) {
        return { notFound: true }
      }
    } else {
      res.setHeader('Cache-Control', 'public, max-age=600')
      const homePageFunction = (await import('../shared/libs/homePage')).getHomePageData
      const data = await homePageFunction('a')
      return {
        props: data
      }
    }
  } catch (e) {
    console.log({ homepage: e })
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
